import React from "react";

const ROLE_INFO = {
  admin:      { label: "Admin",      desc: "Acceso total al sistema",                                 color: "#e74c3c" },
  operator:   { label: "Operador",   desc: "Día a día del taller",                                    color: "#3498db" },
  accountant: { label: "Contador",   desc: "Financieros y dashboard, sin producción ni settings",     color: "#f39c12" },
  seller:     { label: "Vendedor",   desc: "Cotizaciones, OCs cliente, lectura de producción",        color: "#9b59b6" },
};

const RoleSelector = ({ value = [], onChange, disabled = false }) => (
  <div
    className="grid"
    style={{ gridTemplateColumns: "repeat(2, 1fr)", gap: 8 }}
  >
    {Object.entries(ROLE_INFO).map(([key, info]) => {
      const checked = value.includes(key);
      return (
        <label
          key={key}
          className={`bini-role-card${checked ? " checked" : ""}`}
          style={{ borderLeftColor: checked ? info.color : "var(--bini-border)" }}
        >
          <input
            type="checkbox"
            checked={checked}
            disabled={disabled}
            onChange={e => {
              if (e.target.checked) onChange([...value, key]);
              else onChange(value.filter(r => r !== key));
            }}
          />
          <div>
            <div className="role-label">{info.label}</div>
            <div className="role-desc">{info.desc}</div>
          </div>
        </label>
      );
    })}
  </div>
);

export { ROLE_INFO };
export default RoleSelector;
